import React from 'react';
import TryThisOut from '../../pages/tryNow/TryThisOut';

function MexicanIdOCR({ currentProduct, mode }) {
  return (
    <>
      <TryThisOut currentProduct={currentProduct} mode={mode} />
    </>
  );
}

export default MexicanIdOCR;
